/**
 * @Author: Alex Sorafumo <Yuion>
 * @Date:   18/11/2016 4:31 PM
 * @Email:  alex@yuion.net
 * @Filename: time-picker.component.ts
 * @Last modified by:   Alex Sorafumo
 * @Last modified time: 01/02/2017 11:44 AM
 */

import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';

import * as moment_api from 'moment';
import { BaseFormWidgetComponent } from '../../../shared/base-form.component';
const moment = moment_api;

export enum TimePickerPeriod {
    START_HOUR,
    START_MINUTE,
    END_HOUR,
    END_MINUTE
}

@Component({
    selector: 'time-picker',
    styles: [`.time-picker{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-wrap:wrap;flex-wrap:wrap;max-width:100%;height:18em;width:30em;border:1px solid #f0f0f0}@media only screen and (orientation:portrait) and (max-width:450px){.time-picker{width:100%;height:auto}}@media only screen and (orientation:landscape) and (max-width:800px){.time-picker{width:100%;height:auto}}.time-picker.disable{opacity:.2;pointer-events:none}.display{background-color:#ccc;color:rgba(255,255,255,.54);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:10em}@media only screen and (orientation:portrait) and (max-width:450px){.display{height:auto;padding:.5em 0 .25em}}@media only screen and (orientation:landscape) and (max-width:800px){.display{height:auto;padding:.5em 0 .25em}}.time{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.block{position:relative;margin-bottom:8px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.block.divider,.block.hours,.block.minutes{font-size:2.4em}.block.period{margin-left:.5em}.group{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.group-item{padding:.25em 1em}.hours,.minutes,.period{cursor:pointer}.picker{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;padding:1em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;min-height:100%}.clockface{position:relative;height:16em;width:16em;border-radius:100%;background-color:#ccc}.center-point{position:absolute;height:.5em;width:.5em;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);border-radius:100%;background-color:#999}.item,.selection{position:absolute;top:0;left:50%;bottom:50%;width:0;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.selection{-webkit-transition:-webkit-transform .3s;transition:transform .3s,-webkit-transform .3s}.bar{position:absolute;top:.5em;left:-1px;bottom:0;width:2px;background-color:#999}.blob{position:absolute;top:.5em;left:-1em;width:2em;height:2em;border-radius:100%;background-color:#999}.duration{-webkit-transform:translateY(-50%);transform:translateY(-50%)}.value{position:absolute;top:.5em;left:-1em;width:2em;height:2em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-transform-origin:center;transform-origin:center;-webkit-transition:color .3s;transition:color .3s;color:rgba(0,0,0,.87);cursor:pointer}.active{color:#fff}.name{width:100%;text-align:left}.time-input{width:10em;min-width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font-size:1.5em;padding:1em .5em 0}.time-input .field{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;margin-bottom:1em}.time-input .label{font-size:.75em}.time-input .info{font-size:.6em;color:rgba(0,0,0,.54)}.time-input .fvalue{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.time-input .group{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.time-input .group.pad{padding:0 .1em .3em}.time-input input-field{width:2em}.info{font-size:.9em}.transition{pointer-events:none}.toggle{position:absolute;height:1.2em;width:1.2em;top:.25em;right:.25em;font-size:2em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.toggle .icon{height:1em;width:1em;background-position:center;background-repeat:no-repeat;background-size:contain;opacity:.54;-webkit-transition:opacity .2s;transition:opacity .2s}.toggle .icon:hover{opacity:.87}.toggle .icon.keyboard{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0yMCA1SDRjLTEuMSAwLTEuOTkuOS0xLjk5IDJMMiAxN2MwIDEuMS45IDIgMiAyaDE2YzEuMSAwIDItLjkgMi0yVjdjMC0xLjEtLjktMi0yLTJ6bS05IDNoMnYyaC0yVjh6bTAgM2gydjJoLTJ2LTJ6TTggOGgydjJIOFY4em0wIDNoMnYySDh2LTJ6bS0xIDJINXYtMmgydjJ6bTAtM0g1VjhoMnYyem05IDdIOHYtMmg4djJ6bTAtNGgtMnYtMmgydjJ6bTAtM2gtMlY4aDJ2MnptMyAzaC0ydi0yaDJ2MnptMC0zaC0yVjhoMnYyeiIvPgogICAgPHBhdGggZD0iTTAgMGgyNHYyNEgwem0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==)}.toggle .icon.clock{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0xMS45OSAyQzYuNDcgMiAyIDYuNDggMiAxMnM0LjQ3IDEwIDkuOTkgMTBDMTcuNTIgMjIgMjIgMTcuNTIgMjIgMTJTMTcuNTIgMiAxMS45OSAyek0xMiAyMGMtNC40MiAwLTgtMy41OC04LThzMy41OC04IDgtOCA4IDMuNTggOCA4LTMuNTggOC04IDh6Ii8+CiAgICA8cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+CiAgICA8cGF0aCBkPSJNMTIuNSA3SDExdjZsNS4yNSAzLjE1Ljc1LTEuMjMtNC41LTIuNjd6Ii8+Cjwvc3ZnPgo=)}`],
    template: `<div [class]="'time-picker' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '')" widget>
    <div class="display" *ngIf="display">
        <div class="group" *ngIf="!data.manual">
            <div class="group-item">
                <div class="name" *ngIf="range" (touchrelease)="data.active && (data.active.period === 0 || data.active.period === 1) ? '' : select(0)"
                    [class.active]="data.active && (data.active.period === 0 || data.active.period === 1)">
                    Start time
                </div>
                <div class="time start" *ngIf="data.date">
                    <div class="block hours" [class.active]="data.active && data.active.period === 0" (touchrelease)="select(0)" click-responder>{{display.start_hour}}</div>
                    <div class="block divider">:</div>
                    <div class="block minutes" [class.active]="data.active && data.active.period === 1" (touchrelease)="select(1)" click-responder>{{display.start_minute}}</div>
                    <div class="block period" click-responder (touchrelease)="togglePeriod(!display.start_afternoon)">
                        <div class="period" [class.active]="!display.start_afternoon">AM</div>
                        <div class="period" [class.active]="display.start_afternoon">PM</div>
                    </div>
                </div>
            </div>
            <div class="group-item" *ngIf="range">
                <div class="name" (touchrelease)="data.active && (data.active.period === 2 || data.active.period === 3) ? '' : select(2)"
                    [class.active]="data.active && (data.active.period === 2 || data.active.period === 3)">
                    End time
                </div>
                <div class="time end" *ngIf="data.end">
                    <div class="block hours" [class.active]="data.active && data.active.period === 2" (touchrelease)="select(2)" click-responder>{{display.end_hour}}</div>
                    <div class="block divider">:</div>
                    <div class="block minutes" [class.active]="data.active && data.active.period === 3" (touchrelease)="select(3)" click-responder>{{display.end_minute}}</div>
                    <div class="block period" click-responder (touchrelease)="togglePeriod(!display.end_afternoon, 'end')">
                        <div class="period" [class.active]="!display.end_afternoon">AM</div>
                        <div class="period" [class.active]="display.end_afternoon">PM</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="duration" *ngIf="range && display.duration && !data.manual">
            {{display.duration}}
        </div>
        <div class="group" *ngIf="data.manual">
            <div class="block hours active">Set {{range ? 'period' : 'time'}}</div>
        </div>
    </div>
    <div class="picker" [class.afternoon]="data.active && data.active.afternoon" [class.transition]="data.transition">
        <div class="clockface" *ngIf="!data.manual">
            <div class="center-point"></div>
            <div class="selection" [style.transform]="'rotate(' + (360 * (data.selection / data.clock_points.length)) + 'deg)'">
                <div class="bar"></div>
                <div class="blob"></div>
            </div>
            <div class="item" *ngFor="let item of data.clock_points; let i = index" [style.transform]="'rotate(' + (360 * (i / data.clock_points.length)) + 'deg)'">
                <div class="value" (touchrelease)="set(item)" click-responder [class.active]="data.selection === i" [style.transform]="'rotate(-' + (360 * (i / data.clock_points.length)) + 'deg)'" click-responder>
                    {{item.value}}
                </div>
            </div>
        </div>
        <div class="time-input" *ngIf="data.manual">
            <div class="field start">
                <div class="label">Type in {{range ? 'start ' : ''}}time</div>
                <div class="fvalue">
                    <div class="group hr">
                        <input-field [name]="'fill right' + (data.error_sh ? ' error' : '')" [limit]="2" [(model)]="data.start_hour" (modelChange)="checkFields(false)" type="tel"></input-field>
                        <div class="info">hour</div>
                    </div>
                    <div class="group pad">:</div>
                    <div class="group min">
                        <input-field [name]="'fill' + (data.error_sm ? ' error' : '')" [limit]="2" [(model)]="data.start_minute" (modelChange)="checkFields(false)" type="tel"></input-field>
                        <div class="info">minute</div>
                    </div>
                </div>
            </div>
            <div class="field end" *ngIf="range">
                <div class="label">Type in end time</div>
                <div class="fvalue">
                    <div class="group hr">
                        <input-field [name]="'fill right' + (data.error_eh ? ' error' : '')" [limit]="2" [(model)]="data.end_hour" (modelChange)="checkFields()" type="tel"></input-field>
                        <div class="info">hour</div>
                    </div>
                    <div class="group pad">:</div>
                    <div class="group min">
                        <input-field [name]="'fill' + (data.error_em ? ' error' : '')" [limit]="2" [(model)]="data.end_minute" (modelChange)="checkFields()" type="tel"></input-field>
                        <div class="info">minute</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="toggle" *ngIf="manual" (touchrelease)="toggleState()">
            <div class="icon" [class.keyboard]="!data.manual" [class.clock]="data.manual" click-responder></div>
        </div>
    </div>
</div>`,
})
export class TimePickerComponent extends BaseFormWidgetComponent<string> implements OnInit, OnChanges {
    @Input() date: string;
    @Input() duration: number;
    @Input() range = false;
    @Input() manual = true;
    @Output() dateChange = new EventEmitter();
    @Output() durationChange = new EventEmitter();

    public display: { [name: string]: (string | boolean) } = {};

    public ngOnInit() {
        this.data.duration = this.duration;
        if (!this.data.duration) {
            this.data.duration = 60;
        }
        if (!this.data.date) {
            this.data.date = moment();
            this.data.date.minutes(Math.floor(this.data.date.minutes() / 5) * 5);
        }
        if (!this.data.end) {
            this.data.end = moment(this.data.date).add(this.duration || 60, 'm');
        }
        this.generateClockface();
        this.select(TimePickerPeriod.START_HOUR);
        this.data.manual = !this.data.manual;
        this.toggleState();
    }

    public ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (changes.date) {
            const parts = this.date.split(':');
            this.data.date = moment().hours(+parts[0]).minutes(+parts[1]);
            this.data.end = moment(this.data.date).add(this.duration || 60, 'm');
            this.updateDisplay();
        }
        if (changes.duration) {
            this.data.duration = this.duration;
            this.updateEnd();
        }
        if  (changes.manual) {
            this.data.manual = !this.manual;
            this.toggleState();
        }
    }

    /**
     * Generate numbers to display on the clockface
     * @param value Multiples to display
     */
    public generateClockface(value: number = 1, pad: boolean = false) {
        this.data.clock_points = [];
        for (let i = 0; i < 12; i++) {
            const item: any = {
                index: i,
                value: i === 0 && value === 1 ? 12 : i * value
            };
            if (pad) {
                item.value = item.value < 10 ? `0${item.value}` : item.value;
            }
            this.data.clock_points.push(item);
        }
        this.updateDisplay();
    }

    public set(item: any) {
        if (this.data.transition) { return; }
        this.timeout('set', () => {
            this.data.selection = item.index;
            switch(this.data.active.period) {
                case TimePickerPeriod.START_HOUR:
                    this.data.date.hours((+item.value % 12) + (this.data.active.afternoon ? 12 : 0));
                    this.updateEnd();
                    this.data.transition = true;
                    this.timeout('select', () => this.select(1), 800);
                    break;
                case TimePickerPeriod.START_MINUTE:
                    this.data.date.minutes(+item.value);
                    this.updateEnd();
                    break;
                case TimePickerPeriod.END_HOUR:
                    this.data.end.hours((+item.value % 12) + (this.data.active.afternoon ? 12 : 0));
                    this.updateDuration();
                    this.data.transition = true;
                    this.timeout('select', () => this.select(3), 800);
                    break;
                case TimePickerPeriod.END_MINUTE:
                    this.data.end.minutes(+item.value);
                    this.updateDuration();
                    break;
            }
            this.updateDisplay();
        }, 10);
    }

    public select(period: TimePickerPeriod) {
        this.data.transition = false;
        this.data.active = {
            period,
            afternoon: false
        }
        switch(period) {
            case TimePickerPeriod.START_HOUR:
                this.generateClockface()
                this.data.selection = this.data.date.hours() % 12;
                this.data.active.afternoon = this.display.start_afternoon;
                break;
            case TimePickerPeriod.START_MINUTE:
                this.generateClockface(5, true);
                this.data.selection = Math.floor(this.data.date.minutes() / 5);
                this.data.active.afternoon = this.display.start_afternoon;
                break;
            case TimePickerPeriod.END_HOUR:
                this.generateClockface()
                this.data.selection = this.data.end.hours() % 12;
                this.data.active.afternoon = this.display.end_afternoon;
                break;
            case TimePickerPeriod.END_MINUTE:
                this.generateClockface(5, true);
                this.data.selection = Math.floor(this.data.end.minutes() / 5);
                this.data.active.afternoon = this.display.end_afternoon;
                break;
        }
    }

    public togglePeriod(afternoon: boolean = false, name: string = 'date') {
        const hour = this.data[name].hours();
        if (hour >= 12 && !afternoon) { this.data[name].hours(hour % 12); }
        else if (hour < 12 && afternoon) { this.data[name].hours(hour + 12); }
        if (this.data.active) {
            this.data.active.afternoon = afternoon;
        }
        if (name === 'date') {
            this.updateEnd();
        } else {
            this.updateDuration();
        }
        this.updateDisplay();
    }

    public updateDisplay() {
        if (this.data.date) {
            this.display.start_hour = this.data.date.format('hh');
            this.display.start_minute = this.data.date.format('mm');
            this.display.start_afternoon = this.data.date.hours() >= 12;
        }
        if (this.data.end) {
            this.display.end_hour = this.data.end.format('hh');
            this.display.end_minute = this.data.end.format('mm');
            this.display.end_afternoon = this.data.end.hours() >= 12;
        }
        const h = Math.floor((this.data.duration || 60) / 60);
        const m = Math.floor(this.data.duration || 60) % 60;
        this.display.duration = '';
        if (h) { this.display.duration += `${h} hour${h > 1 ? 's' : ''}`; }
        if (m) {
            if (this.display.duration) { this.display.duration += ` `; }
            this.display.duration += `${m} minute${m > 1 ? 's' : ''}`;
        }
    }

    public checkFields(end: boolean = true) {
        this.timeout('check', () => {
                // Check start hour
            if (this.data.start_hour) {
                this.data.error_sh = +this.data.start_hour < 0 || +this.data.start_hour >= 24 || isNaN(this.data.start_hour);
                if (!this.data.error_sh) {
                    this.data.date.hour(+this.data.start_hour);
                }
            }
                // Check start minute
            if (this.data.start_minute) {
                this.data.error_sm = +this.data.start_minute < 0 || +this.data.start_minute >= 60 || isNaN(this.data.start_minute);
                if (!this.data.error_sm) {
                    this.data.date.minute(+this.data.start_minute);
                }
            }
                // Check end hour
            if (this.data.end_hour) {
                this.data.error_eh = +this.data.end_hour < 0 || +this.data.end_hour >= 24 || isNaN(this.data.end_hour);
                if (!this.data.error_eh) {
                    this.data.end.hour(+this.data.end_hour);
                }
            }
                // Check end minute
            if (this.data.end_minute) {
                this.data.error_em = +this.data.end_minute < 0 || +this.data.end_minute >= 60 || isNaN(this.data.end_minute);
                if (!this.data.error_em) {
                    this.data.end.minute(+this.data.end_minute);
                }
            }
            if (end) {
                this.updateDuration()
            } else {
                this.updateEnd();
            }
            this.updateDisplay();
        })
    }

    public toggleState() {
        if (!this.data.date) { return this.timeout('toggle', () => this.toggleState(), 300); }
        this.data.manual = !this.data.manual;
        this.data.start_hour = this.data.date.hours();
        this.data.start_minute = this.data.date.minutes();
        if (this.data.start_minute < 10) { this.data.start_minute = `0${this.data.start_minute}` }
        if (this.data.end) {
            this.data.end_hour = this.data.end.hours();
            this.data.end_minute = this.data.end.minutes();
            if (this.data.end_minute < 10) { this.data.end_minute = `0${this.data.end_minute}` }
            this.select(0);
        }
    }


    private updateEnd() {
        if (this.data.date && this.range) {
            this.data.end = moment(this.data.date);
            this.data.end.add(this.data.duration || 60, 'm');
            this.data.end_hour = this.data.end.hours();
            const m = this.data.end.minutes()
            this.data.end_minute = m < 10 ? `0${m}` : m;
        }
        if (this.data.date) {
            this.dateChange.emit(this.data.date.format('HH:mm'));
        }
        this.updateDisplay();
    }

    private updateDuration() {
        if (this.data.date && this.data.end && this.range) {
            this.data.end.date(this.data.date.date()).add(1, 'd');
            const duration = Math.abs(moment.duration(this.data.end.diff(this.data.date)).asMinutes());
            this.data.duration = duration % (24 * 60);
            if (this.data.end.isBefore(this.data.date)) {
                this.data.duration = 60;
                this.data.date = moment(this.data.end).add(-this.data.duration, 'm');
            }
        }
        if (this.data.duration) {
            this.durationChange.emit(this.data.duration);
        }
        this.updateDisplay();
    }
}
